import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Typography } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { updatePageState } from "../redux/slicePage";
import { RootState } from "../redux/store";
import MuTakoz from "../components/mutakoz";

export default function Result() {
  const dispatch = useDispatch();
  const extract = useSelector((state: RootState) => state.extract);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    dispatch(
      updatePageState({
        navItems: [],
        title: "result",
      })
    );
  }, [dispatch]);

  const columnHeader = extract.headers[extract.selectedColumn] ?? "";
  const preview = extract.extracted.slice(0, 10);

  const copyAll = () => {
    navigator.clipboard.writeText(extract.extracted.join("\n")).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  if (extract.extracted.length === 0) {
    return (
      <Typography>
        No extracted data yet. Go back and apply a regex to a column.
      </Typography>
    );
  }

  return (
    <div>
      <Typography variant="body2" color="textSecondary">
        {columnHeader} · {extract.extracted.length} rows extracted
      </Typography>

      <MuTakoz />

      {preview.map((value, ix) => (
        <div
          key={`extracted_${ix}`}
          className="grid grid-cols-6 gap-1 border-b-4 mt-3"
        >
          <div className="col-span-1 text-center font-bold">{ix + 1}</div>
          <div className="col-span-5 break-all">{value || "—"}</div>
        </div>
      ))}

      <MuTakoz height={"3rem"} />

      <Button
        variant="contained"
        className="w-full"
        startIcon={<ContentCopy />}
        onClick={copyAll}
      >
        {copied ? "Copied!" : "Copy all as column"}
      </Button>
    </div>
  );
}
